export default __webpack_public_path__ + "static/media/33-Boiler-Elevation-Project.d5552e13.jpg";